import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import JoinedguestListLayer from "../../components/JoinedGuestList/JoinedguestListLayer";

const JoinedGuestList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Joined Guest List" />
        <JoinedguestListLayer
          status="joined,scanned"
          viewBasePath="/joinedGuest"
        />
      </MasterLayout>
    </>
  );
};

export default JoinedGuestList;
